import React from 'react';

import { Typography } from '@material-ui/core';
import cn from 'classnames';

import LinkedInIcon from '../../assets/icons/LinkedInIcon';
import { colorsPalette } from '../../theme';
import { useIsIE } from '../../utils/hooks';
import { useTextStyles } from '../../utils/styles';
import { LazyLoadImage } from '../LazyloadImage';
import useStyles from './styles';

const defaultSrcset = [
  { width: 220, height: 290, focus: 'auto' },
];
const defaultSizes = '100vw';
const defaultTransformation = [
  {
    width: 220,
    height: 290,
    focus: 'auto',
  },
];

const TeamMember = ({
  title,
  jobTitle,
  imageUrl,
  link,
  linkTitle,
  isDark = false,
  srcset = defaultSrcset,
  sizes = defaultSizes,
  transformation = defaultTransformation,
  wrapperClass = '',
}) => {
  const classes = useStyles(isDark)();
  const textClasses = useTextStyles();

  //check on IE browser to replace srcset with custom image transformation
  const isIE = useIsIE();

  return (
    <div className={cn(classes.wrapper, wrapperClass)}>
      {imageUrl && (
        <LazyLoadImage
          imageWrapperClass={classes.imageWrapper}
          className={classes.image}
          path={imageUrl}
          alt={title}
          srcset={srcset}
          transformation={isIE ? transformation : null}
          sizes={sizes}
          data-object-fit="cover"
        />
      )}
      <div className={classes.bottom}>
        <Typography variant="h3" className={cn(textClasses.h3, classes.title)}>
          {title}
        </Typography>
        <Typography className={cn(textClasses.metaLabel, classes.jobTitle)}>{jobTitle}</Typography>
        {link && <a
          href={link}
          className={cn(textClasses.meta, classes.link)}
          target="_blank"
          rel="noopener noreferrer"
        >
          <LinkedInIcon className={classes.icon} color={colorsPalette.white} />
          {linkTitle}
        </a>}
      </div>
    </div>
  );
};

export default TeamMember;
